import { ComponentTypeEnum } from "../interface/type";

import { BaseComponent } from "../base/base-component";

import { isMobileLikeMode, isTrueBrowser, isMiniAppLikeMode } from "../../util/env";

import { showTooltip } from "./utils/show-tooltip";

import { isEmptyPos } from "./utils/common";

import { isSameDimensionInfo } from "../../event/events/dimension/util/common";

import { ChartEvent, Event_Source_Type } from "../../constant";

import { GroupTooltipProcessor, DimensionTooltipProcessor, MarkTooltipProcessor } from "./processor";

import { isDimensionInfo, isMarkInfo } from "./processor/util";

import { hasParentElement, isArray, isValid, isNil, array } from "@visactor/vutils";

import { VChart } from "../../core/vchart";

import { Factory } from "../../core/factory";

import { TooltipSpecTransformer } from "./tooltip-transformer";

import { error } from "../../util";

import { TooltipHandlerType } from "./constant";

export class Tooltip extends BaseComponent {
    constructor() {
        super(...arguments), this.layoutZIndex = 1, this.type = ComponentTypeEnum.tooltip, 
        this.name = ComponentTypeEnum.tooltip, this.transformerConstructor = TooltipSpecTransformer, 
        this.specKey = "tooltip", this.layoutType = "none", this._alwaysShow = !1, this._eventList = [], 
        this._isTooltipShown = !1, this._clickLock = !1, this._mountEvent = (eType, query, callback) => {
            this.event.on(eType, query, callback), this._eventList.push({
                eventType: eType,
                handler: callback
            });
        }, this._handleClickToLock = params => {
            this._clickLock ? (this._handleChartMouseOut(params), this._clickLock = !1) : this._clickLock = !0;
        }, this._getMouseOutHandler = needPointerDetection => params => {
            var _a, _b, _c;
            if (this._alwaysShow || this._clickLock) return;
            if (!this._isTooltipShown && !(null === (_b = null === (_a = this.tooltipHandler) || void 0 === _a ? void 0 : _a.isTooltipShown) || void 0 === _b ? void 0 : _b.call(_a))) return;
            const browserEnv = isTrueBrowser(null === (_c = this._option) || void 0 === _c ? void 0 : _c.mode), {clientX: clientX, clientY: clientY} = params.event;
            browserEnv && this._isPointerOnTooltip(params) || browserEnv && needPointerDetection && this._isPointerInChart({
                x: clientX,
                y: clientY
            }) || this._handleChartMouseOut(params);
        }, this._handleChartMouseOut = params => {
            this._alwaysShow || "none" !== this._spec.triggerOff && (this._hideTooltipByHandler(Object.assign(Object.assign({}, params), {
                tooltip: this
            })), this._cacheInfo = void 0, this._cacheParams = void 0, this._cacheActiveType = void 0);
        }, this._getMouseMoveHandler = isClick => params => {
            if (this.tooltipHandler || this._initHandler(), this.processor || this._initProcessor(), 
            this._alwaysShow) return;
            if (this._isPointerOnTooltip(params)) return;
            if (this._clickLock) return void (isClick && (this._handleChartMouseOut(params), 
            this._clickLock = !1));
            const mouseEventData = this._getMouseEventData(params), {tooltipInfo: {dimension: dimensionInfo}, ignore: {mark: ignoreMark, dimension: ignoreDimension}} = mouseEventData, success = {
                mark: !1,
                dimension: !1,
                group: !1
            };
            success.group = this._showTooltipByMouseEvent("group", mouseEventData, params, isClick), 
            success.group || (success.mark = this._showTooltipByMouseEvent("mark", mouseEventData, params, isClick)), 
            success.mark || success.group || (success.dimension = this._showTooltipByMouseEvent("dimension", mouseEventData, params, isClick)), 
            Object.values(success).every((val => !val)) && !isEmptyPos(params) && (ignoreMark && isMarkInfo(this._cacheInfo) ? success.mark = this._showTooltipByMouseEvent("mark", mouseEventData, params, isClick, !0) : ignoreDimension && isDimensionInfo(this._cacheInfo) ? success.dimension = this._showTooltipByMouseEvent("dimension", mouseEventData, params, isClick, !0) : isValid(dimensionInfo) && (success.dimension = this._showTooltipByMouseEvent("dimension", mouseEventData, params, isClick))), 
            success.mark || success.group || success.dimension && !isNil(dimensionInfo) || this._handleChartMouseOut(params);
        }, this._showTooltipByMouseEvent = (activeType, mouseEventData, params, isClick, useCache) => {
            var _a;
            const processor = this.processor[activeType];
            if (!processor.shouldHandleTooltip(params, {
                tooltipInfo: mouseEventData.tooltipInfo[activeType],
                ignore: mouseEventData.ignore[activeType]
            })) return !1;
            let success;
            if (this._timer && clearTimeout(this._timer), useCache) success = !processor.showTooltip(this._cacheInfo, params, !0); else {
                const tooltipInfo = mouseEventData.tooltipInfo[activeType], isSameAsCache = this._isSameAsCache(tooltipInfo, params, activeType);
                success = !processor.showTooltip(tooltipInfo, params, isSameAsCache), success && (this._cacheInfo = tooltipInfo, 
                this._cacheParams = params, this._cacheActiveType = activeType);
            }
            success && (this._isTooltipShown = !0, isClick && this._spec.lockAfterClick && !this._clickLock ? this._clickLock = !0 : Number.isFinite(this._spec.hideTimer) && (this._timer = setTimeout((() => {
                this._handleChartMouseOut();
            }), this._spec.hideTimer)));
            const vchart = null === (_a = this._option) || void 0 === _a ? void 0 : _a.globalInstance;
            return success && VChart.globalConfig.uniqueTooltip && vchart && VChart.hideTooltip(vchart.id), 
            success;
        }, this._getMouseEventData = params => {
            const result = {
                tooltipInfo: {},
                ignore: {}
            };
            let activeType = "dimension";
            const {tooltipInfo: tooltipInfo, ignore: ignore} = this.processor[activeType].getMouseEventData(params);
            result.tooltipInfo[activeType] = tooltipInfo, result.ignore[activeType] = ignore;
            const dimensionInfo = tooltipInfo;
            for (activeType of Object.keys(this.processor)) if ("dimension" !== activeType) {
                const {tooltipInfo: tooltipInfo, ignore: ignore} = this.processor[activeType].getMouseEventData(params, dimensionInfo);
                result.tooltipInfo[activeType] = tooltipInfo, result.ignore[activeType] = ignore;
            }
            return result;
        }, this._hideTooltipByHandler = params => {
            var _a, _b, _c, _d;
            if (!this._isTooltipShown && !(null === (_b = null === (_a = this.tooltipHandler) || void 0 === _a ? void 0 : _a.isTooltipShown) || void 0 === _b ? void 0 : _b.call(_a))) return 0;
            let hideTooltip;
            if (this.event.emit(ChartEvent.tooltipHide, Object.assign(Object.assign({}, params), {
                source: Event_Source_Type.chart,
                tooltip: this
            })), Object.values(this.processor).forEach((processor => {
                processor.clearCache();
            })), (null === (_c = this._spec.handler) || void 0 === _c ? void 0 : _c.hideTooltip) ? hideTooltip = this._spec.handler.hideTooltip.bind(this._spec.handler) : (null === (_d = this.tooltipHandler) || void 0 === _d ? void 0 : _d.hideTooltip) && (hideTooltip = this.tooltipHandler.hideTooltip.bind(this.tooltipHandler)), 
            hideTooltip) {
                const result = hideTooltip(params);
                return result || (this._isTooltipShown = !1), result;
            }
            return 1;
        };
    }
    static getSpecInfo(chartSpec) {
        const tooltipSpec = chartSpec[this.specKey];
        if (!tooltipSpec) return null;
        if (!isArray(tooltipSpec)) return [ {
            spec: tooltipSpec,
            specPath: [ this.specKey ],
            specInfoPath: [ "component", this.specKey, 0 ],
            type: ComponentTypeEnum.tooltip
        } ];
        const specInfos = [];
        return tooltipSpec.forEach(((s, i) => {
            specInfos.push({
                spec: s,
                specPath: [ this.specKey, i ],
                specInfoPath: [ "component", this.specKey, i ],
                type: ComponentTypeEnum.tooltip
            });
        })), specInfos;
    }
    isTooltipShown() {
        return this._isTooltipShown;
    }
    changeRegions(regions) {}
    _getNeedClearVRenderComponents() {
        return [];
    }
    _registerEvent() {}
    _releaseEvent() {}
    onLayout(ctx) {}
    onLayoutEnd(ctx) {}
    onRender(ctx) {}
    created() {
        super.created(), this._regions = this._option.getAllRegions(), this._initEvent();
    }
    release() {
        var _a, _b;
        super.release(), this._timer && clearTimeout(this._timer), this._eventList.forEach((({eventType: eventType, handler: handler}) => {
            this.event.off(eventType, handler);
        })), this._eventList = [], null === (_b = null === (_a = this.tooltipHandler) || void 0 === _a ? void 0 : _a.release) || void 0 === _b || _b.call(_a), 
        this._isTooltipShown = !1;
    }
    beforeRelease() {
        this.event.emit(ChartEvent.tooltipHide, {
            tooltip: this,
            chart: this.getChart()
        }), this.event.emit(ChartEvent.tooltipRelease, {
            tooltip: this,
            chart: this.getChart()
        });
    }
    _initHandler() {
        var _a, _b, _c;
        const renderMode = null !== (_a = this._spec.renderMode) && void 0 !== _a ? _a : "html", userTooltipHandler = this._option.globalInstance.getTooltipHandlerByUser();
        if (userTooltipHandler) this.tooltipHandler = userTooltipHandler; else {
            const type = "canvas" === renderMode ? TooltipHandlerType.canvas : TooltipHandlerType.dom, handlerConstructor = Factory.getComponentPluginInType(type);
            handlerConstructor || error("Can not find tooltip handler: " + type);
            const handler = new handlerConstructor;
            handler.name = `${this._spec.className}-${null !== (_b = this._option.globalInstance.id) && void 0 !== _b ? _b : 0}-${this.getSpecIndex()}`, 
            null === (_c = this.pluginService) || void 0 === _c || _c.load([ handler ]), this.tooltipHandler = handler;
        }
    }
    _initProcessor() {
        this.processor = {
            mark: new MarkTooltipProcessor(this),
            dimension: new DimensionTooltipProcessor(this),
            group: new GroupTooltipProcessor(this)
        };
    }
    _initEvent() {
        var _a;
        if (this._option.disableTriggerEvent) return;
        const trigger = array(null !== (_a = this._spec.trigger) && void 0 !== _a ? _a : "hover"), mode = this._option.mode;
        trigger.includes("hover") && (this._mountEvent("pointermove", {
            source: "chart"
        }, this._getMouseMoveHandler(!1)), (isMobileLikeMode(mode) || isMiniAppLikeMode(mode)) && (this._mountEvent("pointerdown", {
            source: "chart"
        }, this._getMouseMoveHandler(!1)), this._mountEvent("pointerup", {
            source: "window"
        }, this._getMouseOutHandler(!0))), this._mountEvent("pointerout", {
            source: "canvas"
        }, this._getMouseOutHandler(!1))), trigger.includes("click") ? (this._mountEvent("pointertap", {
            source: "chart"
        }, this._getMouseMoveHandler(!0)), this._mountEvent("pointerup", {
            source: "window"
        }, this._getMouseOutHandler(!0))) : this._spec.lockAfterClick && this._mountEvent("pointertap", {
            source: "chart"
        }, this._handleClickToLock);
    }
    reInit(spec) {
        var _a, _b;
        super.reInit(spec), this.tooltipHandler ? null === (_b = (_a = this.tooltipHandler).reInit) || void 0 === _b || _b.call(_a) : this._initHandler();
    }
    showTooltip(datum, options) {
        var _a;
        if (this.tooltipHandler || this._initHandler(), this.processor || this._initProcessor(), 
        !(null === (_a = this.tooltipHandler) || void 0 === _a ? void 0 : _a.showTooltip)) return !1;
        const result = showTooltip(datum, options, this);
        return "none" !== result && (this._alwaysShow = !!(null == options ? void 0 : options.alwaysShow)), 
        result;
    }
    hideTooltip() {
        const params = {
            changePositionOnly: !1,
            tooltip: this,
            item: void 0,
            datum: void 0,
            source: Event_Source_Type.chart
        };
        return this._alwaysShow = !1, !this._hideTooltipByHandler(params);
    }
    _isSameAsCache(nextInfo, nextParams, nextActiveType) {
        if (nextActiveType !== this._cacheActiveType) return !1;
        if (nextInfo === this._cacheInfo) return !0;
        if (isNil(this._cacheInfo) || isNil(nextInfo)) return !1;
        if (isDimensionInfo(nextInfo)) {
            if (isMarkInfo(this._cacheInfo)) return !1;
            const prevInfo = this._cacheInfo;
            if (!(prevInfo.length === nextInfo.length && nextInfo.every(((info, i) => isSameDimensionInfo(info, prevInfo[i]))))) return !1;
        } else {
            if (isDimensionInfo(this._cacheInfo)) return !1;
            const prevInfo = this._cacheInfo;
            if (!((null == nextInfo ? void 0 : nextInfo.datum) === prevInfo.datum && (null == nextInfo ? void 0 : nextInfo.mark) === prevInfo.mark && (null == nextInfo ? void 0 : nextInfo.series) === prevInfo.series)) return !1;
        }
        const prevParams = this._cacheParams;
        return !isNil(prevParams) && !isNil(nextParams) && (prevParams.mark === nextParams.mark && prevParams.model === nextParams.model && prevParams.datum === nextParams.datum);
    }
    _isPointerInChart(point) {
        var _a;
        const globalInstance = null === (_a = this._option) || void 0 === _a ? void 0 : _a.globalInstance;
        if (!globalInstance) return !1;
        if (!globalInstance.getChart()) return !1;
        const {x: x, y: y} = point, canvas = globalInstance.getCanvas(), {x: chartX, y: chartY, width: chartWidth, height: chartHeight} = canvas.getBoundingClientRect();
        return x >= chartX && x <= chartX + chartWidth && y >= chartY && y <= chartY + chartHeight;
    }
    _isPointerOnTooltip(params) {
        var _a, _b;
        if (this._spec.enterable && "html" === this._spec.renderMode) {
            const {event: event} = params;
            let newTarget;
            if (isValid(event.nativeEvent)) {
                const nativeEvent = event.nativeEvent;
                newTarget = nativeEvent.relatedTarget, nativeEvent.composedPath && nativeEvent.composedPath().length > 0 && (newTarget = nativeEvent.composedPath()[0]);
            } else newTarget = event.relatedTarget;
            const container = null === (_b = null === (_a = this.tooltipHandler) || void 0 === _a ? void 0 : _a.getTooltipContainer) || void 0 === _b ? void 0 : _b.call(_a);
            if (isValid(container) && isValid(newTarget) && hasParentElement(newTarget, container)) return !0;
        }
        return !1;
    }
    getVisible() {
        return !1 !== this._spec.visible;
    }
}

Tooltip.type = ComponentTypeEnum.tooltip, Tooltip.transformerConstructor = TooltipSpecTransformer, 
Tooltip.specKey = "tooltip";

export const registerTooltip = () => {
    Factory.registerComponent(Tooltip.type, Tooltip);
};
//# sourceMappingURL=tooltip.js.map
